module.exports = __webpack_public_path__ + "files/68820de90966599e79a3cf573cf089b5.svg";